var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewContainer',{ref:"rootRef",staticClass:"view-input",staticStyle:{"background-color":"transparent","height":"100vh","touch-action":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }